import { Table } from "antd";
import { useState } from "react";
import { getPublicFacilityServices } from "../../helpers/api";
import { useQuery } from "react-query";
import { Chip } from "@mantine/core";

const ServicesPublicModal = ({ facilityId, open, onClose }) => {
  const [filteredData, setFilteredData] = useState([]);

  const {
    data: services,
    isFetching,
    refetch,
  } = useQuery({
    queryFn: () => getPublicFacilityServices(facilityId),
    queryKey: ["public-facility-services", facilityId],
    // enabled: !!facilityId,
    onSuccess: (data) => setFilteredData(data),
  });

  const columns = [
    // {
    //   title: "Code",
    //   width: 100,
    //   sorter: (a, b) => a?.serviceCode > b?.serviceCode,
    //   dataIndex: "serviceCode",
    //   sortDirections: ["descend", "ascend"],
    // },
    {
      title: "Service Name",
      sorter: (a, b) => a?.serviceName > b?.serviceName,
      sortDirections: ["descend", "ascend"],
      width: 300,
      render: (text, record, index) => (
        <span>
          {record?.serviceName}
          {record.isOnline && (
            <span className="bi bi-globe ms-2 text-success" />
          )}
        </span>
      ),
    },
    {
      title: "Rate",
      sorter: (a, b) => a?.baseRate > b?.baseRate,
      sortDirections: ["descend", "ascend"],
      width: 100,
      render: (text, record, index) => record?.baseRate,
    },
    {
      title: "Category",
      width: 150,
      sorter: (a, b) => a?.category?.title > b?.category?.title,
      sortDirections: ["descend", "ascend"],
      render: (text, record, index) => record?.category?.title,
    },
    // {
    //   title: "Bookable",
    //   width: 70,
    //   sorter: (a, b) => a?.isOnline > b?.isOnline,
    //   sortDirections: ["descend", "ascend"],
    //   render: (text, record, index) => (record?.isOnline ? "YES" : "NO"),
    // },
  ];

  return (
    <div>
      <div className="d-flex justify-content-between mb-3">
        <Chip>
          <strong>{filteredData.length || 0}</strong> Services
        </Chip>
      </div>
      <div className="row my-2">
        <div className="col-md-5 col-6 field">
          <input
            className="input"
            onChange={(e) =>
              setFilteredData(
                services?.filter(
                  (s) =>
                    s?.serviceName
                      .toLowerCase()
                      .includes(e.target.value.toLowerCase()) ||
                    s?.category.title
                      .toLowerCase()
                      .includes(e.target.value.toLowerCase()) ||
                    s?.baseRate
                      .toString()
                      .toLowerCase()
                      .includes(e.target.value.toLowerCase())
                )
              )
            }
            title="search here"
            placeholder="search by service name, rate or category"
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <Table
            columns={columns}
            className="border"
            dataSource={filteredData}
            rowKey={(record) => record.id}
            loading={isFetching}
            pagination={false}
          />
        </div>
      </div>
    </div>
  );
};

export { ServicesPublicModal };
